// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refresh_icon {
  cursor: pointer;
  color: #71B03C;
}

.containeres {
  width: 100%;
  display: flex;
  padding: 20px 0;
  align-items: center;
  justify-content: center;
}
.containeres .segment {
  padding: 0 20px;
}
.containeres .segment .block {
  text-align: center;
}
.containeres .segment .block .mat-form-field {
  min-width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/app/views/pages/reports/reports.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,eAAA;AACJ;AAAI;EACE,kBAAA;AAEN;AAAM;EACE,gBAAA;AAER","sourcesContent":[".refresh_icon {\n  cursor: pointer;\n  color: #71B03C;\n}\n\n.containeres {\n  width: 100%;\n  display: flex;\n  padding: 20px 0;\n  align-items: center;\n  justify-content: center;\n\n  .segment {\n    padding: 0 20px;\n    .block {\n      text-align: center;\n\n      .mat-form-field {\n        min-width: 400px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
